export default "__VITE_ASSET__C3rsQLc3__"